import React from 'react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  to: '/about',
  label: 'About'
}, {
  to: '/classes',
  label: 'Classes'
}, {
  to: '/schedule',
  label: 'Schedule'
}, {
  to: '/resources',
  label: 'Resources'
}, {
  to: '/blog',
  label: 'Blog'
}, {
  to: '/proof',
  label: 'Proof'
}];
export function HomeNavigationDesktopMenu() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  return <div className="hidden lg:flex items-center gap-6" data-id="element-532">
      {navLinks.map(link => <Link key={link.to} to={link.to} className={`text-sm font-semibold transition-colors ${isActive(link.to) ? 'text-[#1e3a8a]' : 'text-gray-600 hover:text-[#1e3a8a]'}`} data-id="element-533">
          {link.label}
        </Link>)}
    </div>;
}